<template>
  <b-modal
    id="new-edit-employee-platform"
    ref="modal"
    header-class="headerModal"
    centered
    :title="`${$t('EditEmployee')}: ${employeeName?.employeeName}`"
    size="l"
    hide-footer
    @close="onCancel"
  >
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
      <b-form-group
        :label="$t('Platform')"
      >
        <b-form-input
          v-model="platformName"
          disabled
        />
      </b-form-group>
      <b-form-group
        :label="$t('Filiale')"
      >
        <b-form-input
          v-model="storeName"
          disabled
        />
      </b-form-group>
    </div>
    <b-form-group
      :label="$t('Employeers')"
      style="width:100%;"
      label-for="dummy-id"
    >
      <vue-select
        v-model="employee"
        :options="destinationOptions"
        label="userFullName"
        :reduce="(e) => e.userId"
        :placeholder="$t('Select')"
      />
      <p
        v-if="!employee && buttonSubmited"
        style="color:red;"
      >{{ $t('This_is_a_required_field') }}
      </p>
    </b-form-group>
    <div
      style="margin-top: 5px;"
    >
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"
        @click="onSubmit"
      >
        {{ $t("Submit") }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px"
        @click="onCancel"
      >
        {{ $t("Cancel") }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  props: ['platformName', 'employeeName', 'storeName'],
  data() {
    return {
      employee: null,
      buttonSubmited: false,
    };
  },
  computed: {
    ...mapGetters(['getFreeEmployeesNewPlatform']),
    destinationOptions() {
      return this.getFreeEmployeesNewPlatform.filter((filiale) => {
        return filiale.userId !== this.employees
      })
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([]),
    onSubmit() {
      this.buttonSubmited = true
      if (!this.employee && this.buttonSubmited) {
        return
      }
      const object = {
        employeePlanId: this.employeeName?.employeePlanningId,
        newEmployeeId: this.employee,
      }
      this.$emit('editEmployeePlanning', object)
      this.onReset();
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.employee = null
      this.buttonSubmited = false
      this.$refs.modal.hide();
    },
  },
};
</script>

    <style lang="scss" scoped>
    </style>
